export default function TagsSetFocusOnDirective($timeout, $parse) {
	'ngInject';

	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			var model = $parse(attrs.tagsSetFocusOn);
			var input = element.find('input');
			scope.$watch(model, function(currentValue) {
				if (currentValue === true) {
					$timeout(function() {
						input[0].focus();
					});
				}
			});
			element.bind('blur', function() {
				if (model.assign) {
					scope.$apply(model.assign(scope, false));
				}
			});
		}
	};
}
